<template>
  <v-card
    class="ma-0 py-2 px-4 pt-4"
    style="background: #F5F5F5"
    outlined
    tile
  >
    <validation-observer ref="validator" v-slot="{ handleSubmit }">
      <h3 class="form-title">
        THANH TOÁN NHIỀU LẦN
      </h3>
      <span class="close-btn cursor-pointer" @click="close()">
        <v-icon color="#9e9e9e">
          mdi-close
        </v-icon>
      </span>

      <v-row>
        <v-col class="pt-8 pb-0 d-flex" cols="4">
          <span class="my-auto">
            <v-icon color="#000">
              mdi-circle-small
            </v-icon>
            SỐ TIỀN CÒN LẠI CẦN THANH TOÁN: {{ formatCurrency(totalMoney) }}
          </span>
        </v-col>
        <v-col class="pt-8 pb-0" cols="8">
          <div style="background-color: #0075FF33;border-radius:4px;" class="px-3 py-1">
            <v-icon style="color:#0075FF">mdi-information-slab-circle-outline</v-icon>
            <span style="color:#555555;font-style: italic;" class="mx-1">Hoàn tất thanh toán đơn hàng sẽ tự động mở khóa toàn bộ hạn học, bao gồm hạn học gốc và cả ưu đãi, khuyến mại</span>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-8 pb-0" cols="5">
          <v-row>
            <v-col class="py-0 pt-2">
              <span>
                <v-icon color="#000">
                  mdi-circle-small
                </v-icon>
                SỐ TIỀN THANH TOÁN LẦN 1*: 
              </span>
            </v-col>
            <v-col class="py-0">
              <validation-provider
                v-slot="{ errors }"
                name="Nhập số tiền thanh toán lần 1"
                :rules="{ min_value: 0, max_value: totalMoney, required: true }"
              >
                <v-text-field
                  :error-messages="errors"
                  label=""
                  placeholder="Nhập số tiền thanh toán"
                  dense
                  type="number"
                  v-model="payPrice"
                ></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pt-8 pb-0" cols="5">
          <v-row>
            <v-col class="py-0 pt-2" cols="5">
              <span>
                <v-icon color="#000">
                  mdi-circle-small
                </v-icon>
                Phương thức thanh toán
              </span>
            </v-col>
            <v-col class="py-0">
              <v-select
                :items="paymentTypes"
                item-value="id"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn "
                label=""
                attach
                dense
                outlined
                height="30"
                v-model="paymentType"
                class="customer-pay-select short-w mx-3"
                :menu-props="{ top: true, offsetY: true, maxHeight: '200' }"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-center">
          <v-btn
            class="btn-success"
            @click.prevent="handleSubmit(createOrder)"
            color="#35b707"
            height="38"
            width="100"
            :disabled="isDisable || isDisableCreate"
          >
            <span>Tiếp tục</span>
          </v-btn>

          <v-btn
            class="btn-cancel"
            color="#b70727"
            height="38"
            width="100"
            @click="close()"
          >
            Hủy
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-card>
</template>
<script>
import RepositoryFactory from '@/repositories/RepositoryFactory';
const AddressRepository = RepositoryFactory.get('address');

export default {
  name: 'MultiStepPay2',
  data() {
    return {
      payPrice: null,
      paymentType: 'COD',
      isDisable: false,
    };
  },
  props: {
    paymentTypes: {
      type: Array,
      default: () => [],
    },
    listProvince: {
      type: Array,
      default: () => [],
    },
    products: {
      type: Array,
      default: () => [],
    },
    paymentPeriod: {
      type: Number,
      default: () => null,
    },
    // paymentType: {
    //   type: String,
    //   default: () => null,
    // },
    isNotTrail: {
      type: Boolean,
      default: () => false,
    },
    isTrail: {
      type: Boolean,
      default: () => false,
    },
    receiverName: {
      type: String,
      default: () => null,
    },
    phone: {
      type: String,
      default: () => null,
    },
    detailAddress: {
      type: String,
      default: () => null,
    },
    wardId: {
      type: Number,
      default: () => null,
    },
    districtId: {
      type: Number,
      default: () => null,
    },
    provinceId: {
      type: Number,
      default: () => null,
    },
    paymentPeriods: {
      type: Array,
      default: () => [],
    },
    childs: {
      type: Array,
      default: () => [],
    },
    stepMoney: {
      type: Number,
      default: () => 0,
    },
    contactId: {
      type: Number,
      default: () => null,
    },
  },
  computed: {
    isDisableCreate() {
      const paymentMethod = this.paymentTypes.find(item => item.id === this.paymentType);
      if(paymentMethod &&  paymentMethod.amountRemaining && this.payPrice &&  parseFloat(this.payPrice) > 0) {
        const totalReceipt = paymentMethod && paymentMethod.amountRemaining ? paymentMethod.amountRemaining : 0;
        return parseFloat(this.payPrice) > parseFloat(totalReceipt);
      }
      return false;
    },
    totalMoney() {
      return this.products.reduce((acc, current) => {
        return acc + (current.price * current.count - current.discount);
      }, 0);
    },
  },

  methods: {
    createOrder() {
      // this.isDisable = true;
      if (this.totalMoney == this.payPrice) {
        return this.$swal({
          type: 'error',
          title: 'Thông báo',
          text: 'Số tiền thanh toán bằng số tiền đơn hàng. Đề nghị chuyển sang hình thức thanh toán một lần.',
        });
      }
      this.$emit('createOrder', {
        payPrice: this.payPrice,
        paymentType: this.paymentType,
      });
    },
    close() {
      this.$emit('close');
    },
  },

}
</script>

<style lang="scss" scoped>
.form-title {
  position: absolute;
}
.close-btn {
  position: relative;
  left: 98%;
}
</style>
